import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import User from "../../models/user";

const RECORS_PER_SEARCH = 20;

type UserSelectProps = {
  value: User | null;
  onChange: (_: User | null) => void;
};

const UserSelect: React.FC<UserSelectProps> = ({ value, onChange }) => {
  const loadItemOptions = async (
    s: string,
    currentOpts: readonly (User | { options: User[]; label?: string })[]
  ): Promise<Response<User, { options: User[]; label?: string }, any>> => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const itemsPaginated = await getList<User>(
      "/users/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: User[] = [];
    let count = 0;

    if (itemsPaginated.data !== undefined) {
      newOpts = itemsPaginated.data.items;
      count = itemsPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione un Usuario"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadItemOptions}
      getOptionLabel={(option: User) => `${option.email}`}
      getOptionValue={(option: User) => `${option.id}`}
      value={value}
    />
  );
};

export default UserSelect;
